export enum Flow {
  RLE = 'rle',
  IBW = 'ibw',
  SOLAR = 'solar',
}

export enum Illustration {
  TEAL = 'teal',
  NEUTRAL = 'neutral',
}

export enum ConfigStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
}

export interface Theme {
  primary?: string
  primaryLight?: string
  secondary?: string
  secondaryLight?: string
  text?: string
  background?: string
}

export enum IntegrationType {
  IMMOBILIENSCOUT24 = 'IMMOBILIENSCOUT24',
  IMMOVERKAUF24 = 'IMMOVERKAUF24',
  EXTERNAL = 'EXTERNAL',
}

export interface Config {
  flow: Flow | 'rle'
  coopId: string | undefined
  theme: Theme
  tealium: boolean | true
  illustration: Illustration | 'teal'
  integrationType: IntegrationType
}

export interface Colors {
  background?: string
  primary?: string
  secondary?: string
  text?: string
}

export interface ContactFormWordings {
  headline?: string
  subHeadline?: string
  bulletPointOne?: string
  bulletPointTwo?: string
  bulletPointThree?: string
}

export interface RealEstateWordings {
  headline?: string
  bulletPointOne?: string
  bulletPointTwo?: string
  bulletPointThree?: string
}

export interface Wordings {
  contactForm: ContactFormWordings
  realEstate: RealEstateWordings
}

export interface ConfigFromServer {
  cooperationId: string
  colors?: Colors
  flow?: 'RLE' | 'IBW'
  isIframe?: boolean | false
  status?: ConfigStatus
  tealium?: boolean | true
  wordings?: Wordings
  integrationType?: IntegrationType
  enableFrontendTracking: boolean | false
}

export interface TealiumProfileFromServer {
  counterName?: string
  svcModuleName?: string
  initialPageView?: string
  svcSatelliteWebsite?: string
  addOnClick?: string
}
